import server from "../utils/request.js";
import qs from "qs";
import { dict } from "../utils/base";

import axios from "axios"; //调用本地JSON文件用

// const adminURL = dict.ADMIN_URL;
const adminURL = 'https://djpm.delightmom.com/dlm';


//登录
// export function login () {
//   return server.get('/static/login.json');
// }
export function login (data) {
  return server.post(adminURL + '/api/student/login', qs.stringify(data));
}

//获取激活的班级
export function getInviteClass (data) {
  return server.post(adminURL + '/api/student/getInviteClass', qs.stringify(data));
}

//判断学生是否加入班级
export function agreeInviteClass (data) {
  return server.post(adminURL + '/api/student/agreeInviteClass', qs.stringify(data));
}

//上传文件
export function uploadFile (data) {
  return server.post(adminURL + '/api/school/uploadFile', data);
}

/*
  查询学生首页正在进行的课程
*/
export function getStaetCourse (data) {
  return server.get(adminURL + '/api/stu/course/getStaetCourse', {
    params: data
  });
}

/*
  我的课程
*/
//查询学生课程列表
export function getStuCourseList (data) {
  return server.get(adminURL + '/api/stu/course/getStuCourseList', {
    params: data
  });
}
//根据课程获取课时列表
export function getPeriodList (data) {
  return server.get(adminURL + '/api/teachermgt/getPeriodList', {
    params: data
  });
}
//查询学生课程详情
export function getStudentCourseDetail (data) {
  return server.get(adminURL + '/api/stu/course/getStudentCourseDetail', {
    params: data
  });
}
//上传作品
export function addStuProduct (data) {
  return server.post(adminURL + '/api/teachermgt/addStuProduct', qs.stringify(data));
}
//课程回顾-课程视频
export function getPeriodVideoById (data) {
  return server.get(adminURL + '/api/stu/course/getPeriodVideoById', {
    params: data
  });
}
//课程回顾-教案
export function getPeriodPlanById (data) {
  return server.get(adminURL + '/api/stu/course/getPeriodPlanById', {
    params: data
  });
}
//课程回顾-讲义
export function getPeriodNoteById (data) {
  return server.get(adminURL + '/api/stu/course/getPeriodNoteById', {
    params: data
  });
}
//获取随堂测评
export function getLessonListByStudentId (data) {
  return server.get(adminURL + '/api/studentLessons/getLessonListByStudentId', {
    params: data
  });
}
//提交随堂测评
export function addStudentLessonsRecoder (data) {
  return server.post(adminURL + '/api/studentLessons/addStudentLessonsRecoder', data);
}
//获取我的作品
export function getStuProductById (data) {
  return server.get(adminURL + '/api/teachermgt/getStuProductById', {
    params: data
  });
}
//获取学习报告
export function getCoursePrtiod (data) {
  return server.get(adminURL + '/api/studentLessons/getCoursePrtiod', {
    params: data
  });
}

//创作工具
export function getConfigDownList (data) {
  return server.get(adminURL + '/api/coursedown/getConfigDownList', {
    params: data
  });
}


// WEBPACK FOOTER //
// ./src/api/datas.js